import { events } from "./utilities/event-listeners";
import { ClientScripts, clientScriptSelector as clientSelector, } from "./selectors/clientScripts";
import { iframeResizer as iframeSelector, IframeResizer, } from "./selectors/iframeResizer";
import { initWindowFunctions } from "./utilities/window-functions";
import { providers } from "./providers";
export class VerticalsBridge {
    constructor(constructorInit) {
        this.constructorInit = constructorInit;
    }
    init({ launchData, elementId, user }) {
        initWindowFunctions(this.constructorInit.windowSetup);
        const { clientScriptSelector, iFrameResizer } = launchData;
        let provider;
        switch (true) {
            case clientScriptSelector === ClientScripts.BetGames ||
                iFrameResizer === IframeResizer.BetGames:
            case clientScriptSelector === ClientScripts.GoldenRace ||
                iFrameResizer === IframeResizer.GoldenRace:
            case clientScriptSelector === ClientScripts.Kiron ||
                iFrameResizer === IframeResizer.Kiron:
            case clientScriptSelector === ClientScripts.nsoft ||
                iFrameResizer === IframeResizer.nsoft:
            case clientScriptSelector === IframeResizer.Authentic ||
                iFrameResizer === ClientScripts.Authentic:
            case clientScriptSelector === ClientScripts.IncentiveGames ||
                iFrameResizer === IframeResizer.IncentiveGames:
            case clientScriptSelector === ClientScripts.GlobalBet:
            case clientScriptSelector === ClientScripts.ScoutGaming:
            case clientScriptSelector === ClientScripts.Leap:
            case clientScriptSelector === ClientScripts.Bitville:
            case clientScriptSelector === ClientScripts.TwainSports:
            case clientScriptSelector === ClientScripts.BetGamesNew:
            case clientScriptSelector === ClientScripts.Pragmatic:
            case clientScriptSelector === ClientScripts.OnAirEntertainment:
                provider = clientSelector.get(clientScriptSelector);
                break;
            case iFrameResizer === IframeResizer.TvBet:
            case iFrameResizer === IframeResizer.Evolution:
            case iFrameResizer === IframeResizer.Habanero:
            case iFrameResizer === IframeResizer.BetRadar:
                provider = iframeSelector.get(iFrameResizer);
                break;
            default:
                provider = "StandardGame";
                break;
        }
        providers({ provider, launchData, user, elementId });
        return { provider, events };
    }
}
